<template>
<div id="cabinet_user">
    <link href="/static/css/cabinet/style.css" rel="stylesheet" />
    <link href="/static/css/cabinet/datedropper.min.css" rel="stylesheet"/>
    <div class="container bottom prev">
        <div class="row">
            <div class="silca col-md-120">
                <b>ДАННЫЕ КЛИЕНТА</b> |
                <router-link style="font-size: 16px;" class="previous" to="/cabinet/my">МОЙ АВТО</router-link>
            </div>
            <div class="alert alert-warning col-md-120" role="alert" v-for="item in insurance_policies" :key="item.id" v-if="date(item.date_exp) < date('+60days')">
                Ваша страховка <strong>{{item.insurance_name}}</strong> заканчивается <strong>{{item.date_exp}}</strong>
            </div>
            <div class="alert alert-danger col-md-120" role="alert" style="display: none;"></div>
            <div role="form" ><!-- -->
                <div class="col-md-120" style="margin-top: 20px;" >
                    <div class="row">
                        <div class="col-md-60">
                            <div class="row">
                                <div class="col-md-60">
                                    <div class="form-group clearfix">
                                        <div class="col-md-120">
                                            <input type="text" class="form-control" name="surname"
                                                   placeholder="Фамилия" v-model="auth.famaliname" >
                                        </div>
                                    </div>
                                    <div class="form-group clearfix" >
                                        <div class="col-md-120" >
                                            <select class="js-example-basic-single form-control " style="width: 195.3px !important;" name="city" v-model="citys" >
                                                <option :value="city.id" selected>{{ city.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-60">
                                    <div class="form-group clearfix">
                                        <div class="col-md-120">
                                            <input type="text" class="form-control" name="name"
                                                   placeholder="Имя" v-model="auth.name">
                                        </div>
                                    </div>
                                    <div class="form-group clearfix">
                                        <div class="col-md-120">

                                            <input type="tel" class="form-control" name="phone"
                                                   placeholder="Телефон" required="" v-model="auth.tel" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-60">
                            <div class="row">
                                <div class="col-md-60">
                                    <div class="form-group clearfix">
                                        <div class="col-md-120">
                                            <input type="text" class="form-control" name="patronymic"
                                                   placeholder="Отчество" v-model="auth.patronymic"  >
                                        </div>
                                    </div>
                                    <div class="form-group clearfix">
                                        <div class="col-md-120">
                                            <input type="text" class="form-control" name="email"
                                                   placeholder="Email" v-model="auth.email">
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-60">
                                    <div class="form-group clearfix">
                                        <div class="col-md-120 date_r">

                                            <input type="date" v-model="auth.date"
                                                   class="form-control" name="date"/>
                                            <span class="tooltip_va" data-toggle="tooltip" data-placement="top" title="Мы любим поздравлять наших клиентов">?</span>
                                        </div>
                                    </div>
                                    <div class="form-group clearfix">
                                        <div class="col-md-120">
                                            <input type="submit" class="form-control btn btn-primary" @click="saveAuth" value="Сохранить">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div role="form">
                <div class="col-md-120" style="margin-top: 20px;">
                    <div class="row" style="margin-bottom: 2em;">
                        <div class="col-md-30">
                            <div class="form-group clearfix">
                                <div class="col-md-120">
                                    <input type="password" class="form-control" name="pass" v-model="oldPassword"
                                           placeholder="Ваш пароль">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-30">
                            <div class="form-group clearfix">
                                <div class="col-md-120">
                                    <input type="password" class="form-control" name="newpass" v-model="password"
                                           placeholder="Новый пароь">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-30">
                            <div class="form-group clearfix">
                                <div class="col-md-120">
                                    <input type="password" class="form-control" name="newpass_p" v-model="password2"
                                           placeholder="Повторите пароль">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-30">
                            <div class="form-group clearfix">
                                <div class="col-md-120">
                                    <input type="submit" class="form-control btn btn-primary" @click="savePassword"
                                           value="Сменить пароль">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Add car button -->
            <div class="col-md-120" style="display: none">
                <div class="row">
                    <div class="col-md-60" style="margin-bottom:30px;">
                        <router-link to="/cabinet/">
                            <div class="thumbnail zero-padding clearfix add_auto" style="height: 28em;">
                                <div class="thumbnail_head" >
                                    <h4 class="addauto">ДОБАВИТЬ АВТО</h4>
                                </div>
                                <img style="margin-top: 180px;" src="/static/img/cabinet/plus.png" alt="">
                            </div>
                        </router-link>
                    </div>
                    <cars  :user.sync="user" :city.sync="city" :auth.sync="auth" v-for="item in cars" :key="item.id" :car.sync="item"/>
                </div>
            </div>
            <div class="col-md-120 bonusu" >
                <div class="row">
                    <div class="col-md-28">
                        <h5><b>БОНУСНЫЙ СЧЁТ</b></h5>
                        <div class="thumbnail bonus bonud_p">
                            <p>На вашем счету</p>
                            <p style=" color: #4a8dc6; font-size: 16px;font-weight: bold;">{{auth.bonus}} бонусов</p>
                            <router-link to="/bonus" class="vitr" style="margin-top:32px;">ПОТРАТИТЬ</router-link>
                            / <router-link to="/cabinet/history" class="vitr" style="margin-top:32px;">ИСТОРИЯ</router-link>
                        </div>
                    </div>
                    <div class="col-md-92">
                        <h5><b>КАК ПОЛУЧИТЬ БОНУСЫ, ЧТОБ РЕМОНТИРОВАТЬ АВТО БЕСПЛАТНО</b></h5>
                        <div class="thumbnail bonus">
                            <table class="accia_table">
                                <tr>
                                    <th>XXX {{city.valute}}</th><th>Ввести промокод</th><router-link tag="th" to="/cabinet/promocode"
                                        class="last_th" style="cursor: pointer">ПОЛУЧИТЬ</router-link>
                                </tr>
                                <tr>
                                    <th>500 {{city.valute}}</th><th>За каждого друга которого вы пригласите</th><th
                                        class="last_th" ></th>
                                </tr>
                                <tr>
                                    <th>50% от заказа</th>
                                    <th>За каждого приведенного пользователя, вы будете получать 50% от прибыли заказа, в течении 90 дней после перехода по вашей ссылке или промокоду
                                        <br>
                                        Ваши ссылки для привлечения:
                                        <p v-if="!auth.code">https://в-автосервис.рф/?invite=user{{auth.id}}</p>
                                        <p v-if="!auth.code">Промокод при оформлении заказа: user{{auth.id}}</p>
                                        <p v-if="auth.code">https://в-автосервис.рф/?invite={{auth.code}}</p>
                                        <p v-if="auth.code">Промокод при оформлении заказа: {{auth.code}}</p>
                                    </th>
                                    <router-link tag="th" to="/cabinet/regcode" class="last_th" style="cursor: pointer">СОЗДАТЬ СВОЙ ПРОМОКОД</router-link>
                                </tr>
                                <tr style="display:none;">
                                    <th>10 {{city.valute}}</th><th>Отремонтировали авто? Оставьте отзыв</th><th
                                        class="last_th" ></th>
                                </tr>
                                <tr style="display:none;">
                                    <th>10 {{city.valute}}</th><th>Оставьте информацию о страховании авто</th><th
                                        class="last_th" ></th>
                                </tr>
                                <tr style="display:none;">
                                    <th>10 {{city.valute}}</th><th>Заполните записную книжку Мой авто</th><th
                                        class="last_th" ></th>
                                </tr>
                                <tr style="display:none;">
                                    <th>20 {{city.valute}}</th><th>Напиши отзыв о своей летней резине</th><th
                                        class="last_th" ></th>
                                </tr>
                                <tr style="display:none;">
                                    <th>20 {{city.valute}}</th><th>Напиши отзыв о своей зимней резине</th><th
                                        class="last_th" ></th>
                                </tr>
                                <tr style="display:none;">
                                    <th>20 {{city.valute}}</th><th>Напишите отзыв о своей страховой компании и получите </th><th
                                        class="last_th" ></th>
                                </tr>
                                <tr style="display:none;">
                                    <th>20 {{city.valute}}</th><th>Скачайте мобильное приложение</th><th
                                        class="last_th" ></th>
                                </tr>
                                <tr>
                                    <th>10%</th><th>Cash Back от каждого заказа</th><th
                                        class="last_th" ></th>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'select2'
import Cars from '@/components/cabinet/user/cars'
export default {
  name: 'index',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      citys: this.city.id,
      oldPassword: '',
      password: '',
      password2: '',
      cars: [],
      insurance_policies: []
    }
  },
  components: {
    Cars
  },
  methods: {
    savePassword () {
      if (this.password !== this.password2) alert('Пароли не совпадают')
      else {
        var formData = new FormData()
        formData.append('oldPassword', this.oldPassword)
        formData.append('password', this.password)
        axios.post('https://crm.v-avtoservice.com/list/site-save-password?uid=' + this.user.uid,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          alert(response.data.text)
        })
      }
    },
    saveAuth () {
      setTimeout(function () { alert('Данные обновлены') }, 1)
      var formData = new FormData()
      formData.append('famaliname', this.auth.famaliname)
      formData.append('city_id', this.citys)
      formData.append('name', this.auth.name)
      formData.append('tel', this.auth.tel)
      formData.append('patronymic', this.auth.patronymic)
      formData.append('email', this.auth.email)
      formData.append('date', this.auth.date)
      axios.post('https://crm.v-avtoservice.com/list/site-save-auth?uid=' + this.user.uid,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$root.auth = response.data
      })
    }
  },
  mounted () {
    var $this = this
    $('.js-example-basic-single').select2({
      placeholder: 'Выберите город',
      width: '193.5px',
      ajax: {
        delay: 250,
        type: 'POST',
        url: 'https://crm.v-avtoservice.com/list/site-get-cities',
        dataType: 'json',
        data: function (params) {
          params.lang = $this.$root.city.lang
          params.q = params.term
          return params
        },
        processResults: function (data) {
          return {
            results: $.map(data, function (item) {
              return {
                text: item.text,
                id: item.id
              }
            })
          }
        }
      }
    })
  }
}
</script>

<style scoped>
    .form-control {
        width: 100%;
    }
    .date_r .form-control {
        width: 84%;
    }
</style>



// WEBPACK FOOTER //
// src/components/cabinet/user/index.vue